import { getEnv } from '../../../config/env'

const REACT_APP_API_URL = getEnv('REACT_APP_API_URL')

export const PUBLIC_INSTANCE_CONFIG = {
  baseURL: REACT_APP_API_URL,
  timeout: 30000,
}

export const PRIVATE_INSTANCE_CONFIG = {
  baseURL: REACT_APP_API_URL,
  timeout: 30000,
}
